import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetDeleteLanguages, GetLanguages } from "./thunk";
import { IInitialStateLanguages, ILanguagePayload } from "../types";

const initialState: IInitialStateLanguages = {
    languages: [],
    defaultLanguage: "",
    isLanguagesLoading: false,
    languagesRestoreData: [],
    isViewRestoreLanguage: false,
};

const languagesSlice = createSlice({
    name: "languages",
    initialState,
    reducers: {
        setLanguages: (state, action: PayloadAction<ILanguagePayload[]>) => {
            state.languages = action.payload;
            state.defaultLanguage = action.payload.find(elem => elem.default === 1)?.slug;
        },
        updateLanguages: (state, action: PayloadAction<ILanguagePayload>) => {
            const updatedLanguage = action.payload;
            state.languages = state.languages.map(language => {
                if (updatedLanguage.default === 1) {
                    return language.id === updatedLanguage.id
                        ? { ...language, ...updatedLanguage, default: 1 }
                        : { ...language, default: 0 };
                } else {
                    return language.id === updatedLanguage.id ? updatedLanguage : language;
                }
            });
        },

        deleteLanguages: (state, action: PayloadAction<number>) => {
            state.languages = state.languages.filter(l => l.id !== action.payload);
        },
        selectedDefaultLang: (state, action) => {
            state.defaultLanguage = action.payload;
        },

        setLanguagesRestoreData: (state, action) => {
            state.languagesRestoreData = action.payload;
        },
        deletedRestoreLanguages: (state, action) => {
            state.languagesRestoreData = state.languagesRestoreData.filter(elem => elem.id !== action.payload);
        },
        setIsViewRestoreLanguages: state => {
            state.isViewRestoreLanguage = !state.isViewRestoreLanguage;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetLanguages.pending, state => {
                state.isLanguagesLoading = true;
            })
            .addCase(GetLanguages.fulfilled, state => {
                state.isLanguagesLoading = false;
            })
            .addCase(GetLanguages.rejected, state => {
                state.isLanguagesLoading = false;
            })
            .addCase(GetDeleteLanguages.pending, state => {
                state.isLanguagesLoading = true;
            })
            .addCase(GetDeleteLanguages.fulfilled, state => {
                state.isLanguagesLoading = false;
            })
            .addCase(GetDeleteLanguages.rejected, state => {
                state.isLanguagesLoading = false;
            });
    },
});
export const {
    setLanguages,
    updateLanguages,
    deleteLanguages,
    setLanguagesRestoreData,
    deletedRestoreLanguages,
    setIsViewRestoreLanguages,
    selectedDefaultLang,
} = languagesSlice.actions;
export default languagesSlice;
